var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 61,
    viewBox: "0 0 85 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1797,
    cy: 30.5,
    r: 30,
    fill: "#ECCECE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6495 23.8876L50.7916 38.0298L51.7099 37.1115L37.5678 22.9693L36.6495 23.8876ZM50.727 22.9047L36.5848 37.0468L37.6324 38.0944L51.7745 23.9523L50.727 22.9047Z",
    fill: "#C20000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.17969,
    y: 22.5,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#F9E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.179688,
    y: 32.5,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#F9E5E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1797,
    y: 32.5,
    width: 9,
    height: 8,
    rx: 2,
    fill: "#F9E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1797,
    y: 33.5,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#F9E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1797,
    y: 33.5,
    width: 6,
    height: 8,
    rx: 2,
    fill: "#F9E5E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1797,
    y: 22.5,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#F9E5E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSummary);
export default __webpack_public_path__ + "static/media/remove-summary.7e6a2ae9706bb7bab8934f02548ee749.svg";
export { ForwardRef as ReactComponent };